import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";


import { Card, CardBody, Row, Col, Button, Alert, Table } from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { apiGet, apiPost } from '../../../api'

import "../../../styles/estilos.css";
import Page from "components/Page";
import { Textbox } from "react-inputs-validation";
import { urlActualizarCarritoRefactor,urlGetCatalogoPlanesPymesDiners,urlCargarDatosPlanesPymesDiners } from '../../../constants/urls'

import {
  fetchProcesoCarritoAccP,
  fetchRecuperarCarritoAccP,
} from "../../../redux/actions/aRamoAccidentesPersonales";
import AccPersonalTooltip from "../../Widget/tooltips/AccPersonalTooltip";

class CotizacionPlanesDiners extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      numDias: "",
      hasNumDiasError: true,
      selPlan: false,
      idPlan: "",
      numPersonas: "",
      estructura: {},
      loading: true,
      errorCantidad: false,
      idCarrito: "",
      mostrarDistribucionPersonas: "",
      optionSelected: undefined,
      countValores: 0,
      plan: [],
      categorias: [],
      selectedContenido: ""
    };


    //this.onClickRegresar = this.onClickRegresar.bind(this);
    //this.validateForm = this.validateForm.bind(this);
    //this.asignarNumeroPersonas = this.asignarNumeroPersonas.bind(this);
  }

  actualizarCarrito = async (producto) => {
    try {
      const valoresPagar = {
        valorTotal: {
          totalcarrito: producto,
          prima_neta_anual_full_cobertura:producto
        }
      }
      const response = await apiPost(
        `${urlActualizarCarritoRefactor}${this.props.id}`, 
        valoresPagar
      );

      console.log("Datos obtenidos:", response);

      // Verificar si la respuesta es un objeto
      if (response !== null) {
        // Forzar cambio de referencia
        this.setState({ loading: false });
      } else {
        console.error("El API no devolvió un objeto válido:", response);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
      this.setState({ loading: false });
    }
  }


  cargarDatosDesdeAPICategorias = async () => {
    try {
      const response = await apiGet(
        urlGetCatalogoPlanesPymesDiners
      );

      console.log("Datos obtenidos:", response);

      // Verificar si la respuesta es un objeto
      if (response !== null) {
        // Forzar cambio de referencia
        this.setState({ categorias: response.data, loading: false });
      } else {
        console.error("El API no devolvió un objeto válido:", response);
        this.setState({ categorias: {}, loading: false });
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
      this.setState({ categorias: {}, loading: false });
    }
  };


  cargarDatosDesdeAPIContenidos = async (categoria) => {
    if (!categoria) return;
    try {
      const response = await apiGet(`${urlCargarDatosPlanesPymesDiners}${categoria}`);

      console.log("Datos obtenidos:", response);

      // Verificar si la respuesta es un objeto
      if (response !== null) {
        // Forzar cambio de referencia
        this.setState({ plan: response.data, loading: false });
      } else {
        console.error("El API no devolvió un objeto válido:", response);
        this.setState({ plan: {}, loading: false });
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
      this.setState({ plan: {}, loading: false });
    }
  };

  handleSeleccionar = (producto) => {

    this.actualizarCarrito(producto);
    const { id } = this.props;
    this.props.history.push({
      pathname: '/pymesDiners/cotizador',
      search: `?paso=4&id=${id}`,
      state: { productoSeleccionado: producto }
    });
  };


  handleSelectChange = (event) => {
    const selectedCategory = event.target.value;
    this.setState(
      { selectedContenido: selectedCategory, loading: true },
      () => {
        // Cargar los datos con la categoría seleccionada
        this.cargarDatosDesdeAPIContenidos(selectedCategory);
      }
    );
  };


  componentDidMount() {
    //console.clear();
    window.scroll(0, 0);



    this.cargarDatosDesdeAPICategorias();

  }


  componentDidUpdate(prevProps, prevState) {
    // Comprobar si el estado plan ha cambiado
    if (prevState.categorias !== this.state.categorias) {
      console.log('Datos actualizados:', this.state.categorias);
    }

    if (prevState.plan !== this.state.plan) {
      console.log('Datos actualizados:', this.state.plan);
    }
  }



  render() {
    const {
      selPlan,
      numDias,
      validate,
      errorCantidad,
      mostrarDistribucionPersonas,
      plan,
      categorias,
      categoriaSeleccionada
    } = this.state;
    //console.log(categorias);
    console.log(typeof plan.coberturas);


    let isLoading =

      this.state.loading;



    if (isLoading) {
      return (
        <LoadingScreen
          loading={true}
          bgColor="#f1f1f1"
          spinnerColor="#001871"
          textColor="#676767"
          text="Obteniendo datos..."
        />
      );
    }



    return (
      <div>
        <label htmlFor="contenidos">Selecciona un contenido:</label>
        <select
          id="contenidos"
          value={this.state.selectedContenido}
          onChange={this.handleSelectChange}
        >
          {/* Opción por defecto */}
          <option value="">Selecciona un contenido</option>

          {categorias.map((contenido, index) => (
            <option key={contenido.nombre} value={contenido.nombre}>
              {contenido.nombre}
            </option>
          ))}
        </select>



        <Table bordered>
          <thead>
            <tr>
              <th>Cobertura</th>
              {/* Creamos las cabeceras dinámicamente basadas en las opciones de la primera cobertura */}
              {plan && plan.length > 0
                ? plan[0].valores.map((producto, index) => (
                  <th key={index}>{producto.nomOpcion}</th>
                ))
                : null}
            </tr>
          </thead>

          <tbody>
            {/* Recorremos todas las coberturas */}
            {plan && plan.length > 0
              ? plan.map((cobertura, index) => (
                <tr key={index}>
                  <td>{cobertura.nombreCobertura}</td>
                  {/* Recorremos los valores de cada cobertura */}
                  {cobertura.valores.map((producto, idx) => (
                    <td key={idx}>${producto.valorMaximo}</td>
                  ))}
                </tr>
              ))
              : null}

            <tr>
              {plan && plan.length > 0 ? <td>TOTAL</td> : null}
              {plan && plan.length > 0
                ? plan[0].valores.map((producto, index) => (
                  <th key={index}>{producto.prima}</th>
                ))
                : null}
            </tr>

            {/* Nueva fila para los botones */}
            <tr>
              {plan && plan.length > 0 ? <td></td> : null}
              {plan && plan.length > 0
                ? plan[0].valores.map((producto, index) => (
                  <td key={index}>
                    <button onClick={() => this.handleSeleccionar(producto.prima)}>Seleccionar</button>
                  </td>
                ))
                : null}
            </tr>
          </tbody>

        </Table>
      </div>

    )

  }

}




export default withRouter(
  connect(null, null)(CotizacionPlanesDiners)
);
